module.exports = __webpack_public_path__ + "img/version_img5.c398bd4f.png";